import '@/features/trainings/styles/train.css';
import { ReadOnlyGuard, Text } from '@spark';
import React from 'react';

import {
    AimOutlined,
    CloudUploadOutlined,
    CodepenOutlined,
    StopOutlined,
    ArrowDownOutlined,
    LikeOutlined,
    DislikeOutlined,
    LoadingOutlined,
} from '@ant-design/icons';

import {
    Card, Row, Col, Button, Tag, Checkbox,
    Image, InputNumber,
} from 'antd';
import { colors } from '@/shared/tokens/colors';
import getDeployementData from './DeployementDefaultData.jsx';
import { status } from '../constants/status';
import CollapsedDeployemets from './CollapsedDeployemets.jsx';
import RemoveABTestingModal from './RemoveABTestingModal.jsx';

const initialDeployementsToShow = [status.deployed_and_running, status.ab_testing, status.serving_paused, status.serving_ready]

function getDiffKeys(a, b) {
    const bKeys = new Set(b);
    return a.filter(key => !bKeys.has(key));
}

const { Meta } = Card;

const shortCardMeta = (data, moveToPlayground, noFeedback, handleDeployClick) => {
    let color = "gray"
    let tag_text = "unknown"
    let deploy_button_text = "unknown"
    if (data.status === status.deployed_and_running || data.status === status.ab_testing) {
        color = colors.green
        tag_text = "Deployed"
        deploy_button_text = "Pause"
    } else if (data.status === status.serving_paused) {
        color = colors.gray
        tag_text = "Paused"
        deploy_button_text = "Deploy"
    } else if (data.status === status.serving_ready) {
        color = colors.orange
        tag_text = "Ready to deploy"
        deploy_button_text = "Deploy"
    }
    const outline = deploy_button_text === "Pause" ? <StopOutlined /> : <CloudUploadOutlined />
    const deploy_color = data.status === status.serving_ready ? colors.green : colors.buttonsBlue
    const added_style = data.status === status.serving_ready ? { borderWidth: '2px' } : {}
    const sumThumbs = data.thumbs_up + data.thumbs_down
    let thumbsUpPercent
    let thumbsDownPercent
    if (sumThumbs === 0) {
        thumbsUpPercent = 0
        thumbsDownPercent = 0
    } else {
        thumbsUpPercent = (data.thumbs_up / (data.thumbs_up + data.thumbs_down) * 100).toFixed(2)
        thumbsUpPercent = Math.round(thumbsUpPercent * 100) / 100
        thumbsDownPercent = Math.round((100 - thumbsUpPercent) * 100) / 100
    }
    return <div>
        <div>
            <Meta
                title={data.title}
                description={
                    <div>
                        <div>last trained: {data.last_trained}</div>
                        <div>base model: {data.base_model_name}</div>
                        <div>dataset: {data.dataset_name}</div>
                        <div>dataset entries: {data.dataset_entries}</div>
                        <div>dataset size: {data.dataset_size}</div>
                        <div style={{ marginTop: '5px' }}>status: <Tag color={color}>{tag_text}</Tag></div>
                        {!noFeedback && <div style={{ marginTop: '5px' }}>feedback: <span style={{ marginLeft: '10px', color: colors.green }}>{data.thumbs_up} <span style={{ fontWeight: 'bold' }}>({thumbsUpPercent}%)</span> <LikeOutlined /></span>
                            <span style={{ marginLeft: '10px', color: colors.red }}>{data.thumbs_down} <span style={{ fontWeight: 'bold' }}>({thumbsDownPercent}%)</span> <DislikeOutlined style={{ marginTop: "7px" }} /></span></div>}
                        <div>
                            <div>benchmark evaluation: </div>
                            <div style={{ marginLeft: "15px" }}>- my golden data: {data.my_golden_data}</div>
                            <div style={{ marginLeft: "15px" }}>- test internal: {data.test_internal}</div>
                        </div>
                    </div>
                }
            />
            <ReadOnlyGuard>
                <Button
                    onClick={handleDeployClick || (() => { })}
                    style={{ color: colors.buttonsBlue, borderColor: deploy_color, width: "100%", marginTop: "25px", ...added_style }}
                >{outline}{deploy_button_text}</Button>
            </ReadOnlyGuard>
            <Button
                onClick={() => moveToPlayground(data.title)}
                style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, width: "100%", marginTop: "10px" }}
            ><CodepenOutlined />Playgorund</Button>
        </div>
    </div >
}

export const longCardMeta = (deployementsToshow, moveToPlayground, data, index, exposure, inputOutputImageSrc, latencyImageSrc) => {
    const cover = <AimOutlined style={{ fontSize: '70px' }} />
    const card_style = { width: '19.3vw', cursor: "auto", border: '0' }
    if (deployementsToshow.includes(data.status)) {
        const imageStyle = { width: "24.5vw", cursor: 'auto' }

        return <div>
            <Card
                hoverable
                style={{ width: "81vw" }}
                extra={data.status !== 'A/B Testing' ?
                    <ReadOnlyGuard>
                        <Button style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue }} onClick={() => alert("Let's start A/B Testing!")
                        }>
                            A/B Testing
                        </Button>
                    </ReadOnlyGuard> : ""}
                bordered={false}
            >
                <div style={{ display: 'flex', justifyContent: 'right', marginBottom: '-55px', position: 'relative', zIndex: 1 }}>
                    {exposure}
                </div>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                    <div flex={2}>
                        <Card
                            style={card_style} cover={cover}
                        >
                            {shortCardMeta(data, moveToPlayground)}
                        </Card>
                    </div>
                    <div flex={3} style={{ display: 'flex', alignItems: 'center', flexDirection: "column", justifyContent: "center" }}>
                        <Image
                            src={inputOutputImageSrc || './images/input-output-tokens1.png'}
                            style={imageStyle}
                        />
                        <div style={{ display: 'flex', alignItems: "center", flexDirection: "row", justifyContent: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "30px", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>1000</div>
                                <div>Total Requests</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "30px", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>160</div>
                                <div>Avg. Requests</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>230</div>
                                <div>Max Requests</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: "center", flexDirection: "row", justifyContent: "center", marginTop: "15px" }}>
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "30px", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>60</div>
                                <div>Avg. Input Tokens</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>154</div>
                                <div>Avg. Output Tokens</div>
                            </div>
                        </div>
                    </div>
                    <div flex={3} style={{ display: 'flex', alignItems: 'center', flexDirection: "column", justifyContent: "center" }}>
                        <Image
                            src={latencyImageSrc || './images/latency1.png'}
                            style={imageStyle}
                        />
                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", marginRight: "30px", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>8.5 ms</div>
                                <div>Avg. Latency</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ fontWeight: 'bold' }}>16ms</div>
                                <div>Max Latency</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    }
    return null
}

function renderLongCard(deployementsToshow, moveToPlayground, data, index) {
    if (deployementsToshow.includes(data.status)) {
        return <Row key={index} lg={6} style={{ marginBottom: "30px" }}>
            {longCardMeta(deployementsToshow, moveToPlayground, data, index)}
        </Row>
    }
    return null
}

function renderShortCard(deployementsToshow, moveToPlayground, data, index, noFeedback, handleDeployClick) {
    const cover = <AimOutlined style={{ fontSize: '70px', paddingTop: '50px' }} />
    const card_style = { width: '19.3vw', cursor: "auto" }
    if (deployementsToshow.includes(data.status)) {
        return <Col key={index} lg={6} style={{ marginTop: "30px" }}>
            <Card
                hoverable
                style={card_style}
                cover={cover}
                extra={data.status !== 'A/B Testing' ?
                    <ReadOnlyGuard>
                        <Button style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue }} onClick={() => alert("Let's start A/B Testing!")
                        }>
                            A/B Testing
                        </Button>
                    </ReadOnlyGuard> : ""}
            >
                {shortCardMeta(data, moveToPlayground, noFeedback, handleDeployClick)}
            </Card>
        </Col>
    }
    return null
}

export class Deployment extends React.Component {

    constructor(props) {
        super(props);
        this.readyToDeployRef = React.createRef();
        this.state = {
            deployementsData: getDeployementData(this.props.currentModel),
            deployementsToShow: initialDeployementsToShow,
            ABTestingActiveKey: [],
            deployedActiveKey: [],
            pausedActiveKey: [],
            readyToDeployActiveKey: [1],
            abTestingModalOpen: false,
            isLoading: false,
        }
        this.getDeployementsCards = this.getDeployementsCards.bind(this)
        this.setDeployementsToShow = this.setDeployementsToShow.bind(this)
        this.scrollToReadyToDeploy = this.scrollToReadyToDeploy.bind(this)

        this.handleDeployedPanelChange = this.handleDeployedPanelChange.bind(this)
        this.handlePausedPanelChange = this.handlePausedPanelChange.bind(this)
        this.handleReadyToDeployPanelChange = this.handleReadyToDeployPanelChange.bind(this)
        this.handleABTestingPanelChange = this.handleABTestingPanelChange.bind(this)
        this.renderABTestingCard = this.renderABTestingCard.bind(this)
        this.handleExposureChange = this.handleExposureChange.bind(this)
        this.handleDeployClick = this.handleDeployClick.bind(this)
    }

    handleABTestingPanelChange = (key) => {
        this.setState((prevState) => ({ ABTestingActiveKey: prevState.ABTestingActiveKey.length > 0 ? [] : [key] }))
    };
    handleDeployedPanelChange = (key) => {
        this.setState((prevState) => ({ deployedActiveKey: prevState.deployedActiveKey.length > 0 ? [] : [key] }))
    };
    handlePausedPanelChange = (key) => {
        this.setState((prevState) => ({ pausedActiveKey: prevState.pausedActiveKey.length > 0 ? [] : [key] }))
    };
    handleReadyToDeployPanelChange = (key) => {
        this.setState((prevState) => ({ readyToDeployActiveKey: prevState.readyToDeployActiveKey.length > 0 ? [] : [key] }))
    };

    setDeployementsToShow(options) {
        this.setState({ deployementsToShow: options })
    }

    updateValues = (dataItem) => {
        if (dataItem.status === status.ab_testing) {
            return {
                first_model_exposure: dataItem.first_model_exposure,
            };
        }
        return {};
    };

    getExposure = (value, key) => {
        return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ display: 'flex' }}>
                <div style={{ marginRight: "5px", display: 'flex', alignItems: 'center' }}>Exposure (%) :</div>
                <InputNumber
                    style={{ width: "55px", marginLeft: "10px" }}
                    value={value}
                    onChange={(value) => this.handleExposureChange(value, key, false)}
                    min={"0"}
                    max={"100"}
                />
            </div>
            <div
                style={{ marginLeft: "10px", fontSize: "30px", display: 'flex' }}>
                <ReadOnlyGuard>
                    <Button
                        style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue }}
                        onClick={() => {
                            if (value === 0 || value === 100) {
                                this.setState({ abTestingModalOpen: true })
                            }
                            else {
                                alert("New Exposure Saved!")
                            }
                        }}>Save</Button>
                </ReadOnlyGuard>
            </div>
        </div>
    }

    handleExposureChange = (value, key, reverse) => {
        const updatedData = this.state.deployementsData.map((item) => {
            if (item.key === key && item.status === 'A/B Testing') {
                return { ...item, ...{ first_model_exposure: reverse ? 100 - value : value } }; //TODO: check e.value
            }
            return item;
        });
        let addedState = {}
        this.setState({ deployementsData: updatedData, ...addedState });
    };

    renderABTestingCard(deployementsToshow, moveToPlayground, data, index) {

        const first_exposure = this.getExposure(data.first_model_exposure, data.key)
        const second_exposure = this.getExposure(100 - data.first_model_exposure, data.key)

        if (deployementsToshow.includes(data.status)) {
            return <Row key={index} lg={6} style={{ marginBottom: "30px" }}>
                <Card
                    style={{ width: "83vw" }}
                    title={data.title}
                >
                    <div>
                        {longCardMeta(
                            deployementsToshow,
                            moveToPlayground,
                            data.first_model,
                            index + data.first_model.key,
                            first_exposure,
                        )}
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        {longCardMeta(
                            deployementsToshow,
                            moveToPlayground,
                            data.second_model,
                            index + data.second_model.key,
                            second_exposure,
                            './images/input-output-tokens2.png',
                            './images/latency2.png'
                        )}
                    </div>
                </Card>
            </Row>
        }
        return null
    }

    handleDeployClick() {
        this.setState({ isLoading: true }, () => {
            setTimeout(() => {
                //readyToDeployActiveKey, deployedActiveKey
                this.setState((prevState) => ({
                    isLoading: false,
                    readyToDeployActiveKey: [],
                    deployedActiveKey: [1],
                    deployementsData: [{ ...prevState.deployementsData[0], status: status.deployed_and_running }]
                }))
            }, 1500)
        })
        this.setState((prevState) => ({ deployementsData: [{ ...prevState.deployementsData[0], status: status.deployed_and_running }] }))
    }

    getDeployementsCards(moveToPlayground, deployementsToShow) {
        const cardData = this.state.deployementsData
        const abTesting = (
            <Col gutter={32}>
                {
                    cardData
                        .filter(d => d.status === 'A/B Testing')
                        .map((data, index) => this.renderABTestingCard(deployementsToShow, moveToPlayground, data, index))
                }
            </Col>
        );
        const deployed = (
            <Col gutter={32}>
                {
                    cardData
                        .filter(d => d.status === "Deployed")
                        .map((data, index) => renderLongCard(deployementsToShow, moveToPlayground, data, index))
                }
            </Col>
        );
        const paused = (
            <Col gutter={32}>
                {
                    cardData
                        .filter(d => d.status === "Paused")
                        .map((data, index) => renderLongCard(deployementsToShow, moveToPlayground, data, index))
                }
            </Col>
        );
        const readyToDeploy = (
            <Row gutter={32}>
                {
                    cardData
                        .filter(d => d.status === "Ready to deploy")
                        .map((data, index) => renderShortCard(deployementsToShow, moveToPlayground, data, index, true, this.handleDeployClick))
                }
            </Row>
        );

        return {
            abTesting,
            deployed,
            paused,
            readyToDeploy,
        }

    }

    scrollToReadyToDeploy() {
        this.readyToDeployRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    render() {
        const deployments = this.getDeployementsCards(this.props.moveToPlayground, this.state.deployementsToShow)
        return (<div
            className='deployments page-content-shell'
        >
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><Text variant="h2" style={{ fontSize: '30px', fontWeight: 350, whiteSpace: 'nowrap' }}>Deployments</Text></div>
                <Row>
                    <Checkbox.Group
                        options={initialDeployementsToShow}
                        defaultValue={this.state.deployementsToShow}
                        onChange={(deployementsToShow) => {
                            let newState = { deployementsToShow }
                            const keys = getDiffKeys(deployementsToShow, this.state.deployementsToShow, deployementsToShow)
                            if (keys.includes(status.deployed_and_running)) {
                                newState = { ...newState, deployedActiveKey: [1] }
                            }
                            if (keys.includes(status.serving_paused)) {
                                newState = { ...newState, pausedActiveKey: [1] }
                            }
                            if (keys.includes(status.serving_ready)) {
                                newState = { ...newState, readyToDeployActiveKey: [1] }
                            }
                            this.setState(newState)
                        }}
                        style={{ marginTop: "10px", display: 'flex' }}
                    />
                    {deployments.readyToDeploy && <Button
                        onClick={this.scrollToReadyToDeploy}
                        style={{ marginLeft: 'auto', color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                    >Scroll to "Ready to deploy"<ArrowDownOutlined /></Button>}
                </Row>
                {this.state.isLoading && <div style={{ color: colors.buttonsBlue, fontSize: "80px", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                    <LoadingOutlined />
                </div>}
                {!this.state.isLoading && <div>
                    <CollapsedDeployemets
                        abTesting={deployments.abTesting}
                        deployed={deployments.deployed}
                        paused={deployments.paused}
                        readyToDeploy={deployments.readyToDeploy}

                        deployementsToShow={this.state.deployementsToShow}
                        readyToDeployRef={this.readyToDeployRef}

                        ABTestingActiveKey={this.state.ABTestingActiveKey}
                        deployedActiveKey={this.state.deployedActiveKey}
                        pausedActiveKey={this.state.pausedActiveKey}
                        readyToDeployActiveKey={this.state.readyToDeployActiveKey}

                        handleDeployedPanelChange={this.handleDeployedPanelChange}
                        handlePausedPanelChange={this.handlePausedPanelChange}
                        handleReadyToDeployPanelChange={this.handleReadyToDeployPanelChange}
                        handleABTestingPanelChange={this.handleABTestingPanelChange}
                    />
                    <RemoveABTestingModal
                        isOpen={this.state.abTestingModalOpen}
                        handleOk={() => {
                            const data = this.state.deployementsData
                            const dataWithoutABTesting = data.filter(d => d.status !== status.ab_testing)
                            const ABTestingData = data.filter(d => d.status === status.ab_testing)
                            const deployementsData = [...ABTestingData.map(d => {
                                const model = d.first_model
                                model.status = status.deployed_and_running
                                return model
                            }), ...ABTestingData.map(d => {
                                const model = d.second_model
                                model.status = status.serving_paused
                                return model
                            }), ...dataWithoutABTesting]
                            this.setState({ abTestingModalOpen: false, deployementsData })
                        }}
                        handleCancel={() => { this.setState({ abTestingModalOpen: false, deployementsData: getDeployementData(this.props.currentModel) }) }}
                    />
                </div>
                }
            </div>
        </div>);
    }
}


